import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import TeacherForm from 'components/organisms/forms/TeacherForm'

import { crudActionsMap } from 'utils/helpers'

const TeacherCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.teachers')} / ${t('common.' + action)}`} />
      <PageBody>
        <TeacherForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default TeacherCrudPage
